import moment from 'moment'

export type NewsItemAttrs = {
  id?: number
  time?: string
  title?: string
  description?: string
}

export default class NewsItem {
  public id?: number
  public time: string
  public title: string
  public description: string

  constructor({ id, time, title, description }: NewsItemAttrs) {
    this.id = id
    this.time = time || moment().format()
    this.title = title || ''
    this.description = description || ''
  }

  formatTime() {
    const time = moment(this.time)

    return time.format('YYYY年MM月DD日HH時mm分')
  }

  toParams() {
    const { id, time, title, description } = this

    return { id, time, title, description }
  }

  isTodayNews() {
    const diff = Math.abs(moment(this.time).diff(moment(), 'hours'))

    return diff <= 24
  }
}
